import { all, put, takeEvery } from "redux-saga/effects";
import { generaLog } from "../../functions/utils";
import { getCampagneAttiveScreeningActionSuccess } from "./actions";
import { resetMessaggioStateAction, setMessaggioAction } from "../messaggio/actions";
import { LOADING } from "../../global/statusLabels";
import { getCampagneAttiveScreeningApiTS } from "../../api/apiFunctionsScreening";
import { ASL_3, ASL_5 } from "../../global/multiAsl";
import { GET_CAMPAGNE_ATTIVE_SCREENING } from "./actionsType";
import { ERRORE_GENERICO_API, ERRORE_SESSION_EXPIRED, ERRORE_UNAUTHORIZED } from "../../global/messaggioLabels";


function* getCampagneAttiveScreeningWorker() {
    generaLog("getCampagneAttiveScreeningWorker", "log")
    yield put(getCampagneAttiveScreeningActionSuccess({ value: undefined, status: LOADING }))
    yield put(setMessaggioAction({ status: LOADING }))
    let responseAsl3;
    let responseAsl5;
    let arr1 = [];
    let arr2 = [];
    let erroreAsl3, erroreAsl5;

    // --- ASL3 ---
    try {
        responseAsl3 = yield getCampagneAttiveScreeningApiTS(ASL_3.codice)
    } catch (error) {
        if (error?.response?.status === 401) {
            yield put(setMessaggioAction({ status: ERRORE_UNAUTHORIZED }))
            yield put(getCampagneAttiveScreeningActionSuccess({ value: error?.response?.data, status: error?.response?.status }))
        } else if (error === ERRORE_SESSION_EXPIRED || error?.response?.status === 409) {
            yield put(setMessaggioAction({ status: ERRORE_SESSION_EXPIRED }))
            yield put(getCampagneAttiveScreeningActionSuccess({ value: error?.response?.data, status: error?.response?.status }))
        }
        else {
            generaLog("Errore: " + error)
            erroreAsl3 = { value: error?.response?.data, status: error?.response?.status };
        }
    }
    if (responseAsl3?.status === 200) {
        arr1 = responseAsl3?.data.map(v => ({ ...v, asl: ASL_3.codice }))
    }

    // --- ASL5 ---
    try {
        responseAsl5 = yield getCampagneAttiveScreeningApiTS(ASL_5.codice)
    } catch (error) {
        if (error?.response?.status === 401) {
            yield put(setMessaggioAction({ status: ERRORE_UNAUTHORIZED }))
            yield put(getCampagneAttiveScreeningActionSuccess({ value: error?.response?.data, status: error?.response?.status }))
        } else if (error === ERRORE_SESSION_EXPIRED || error?.response?.status === 409) {
            yield put(setMessaggioAction({ status: ERRORE_SESSION_EXPIRED }))
            yield put(getCampagneAttiveScreeningActionSuccess({ value: error?.response?.data, status: error?.response?.status }))
        }
        else {
            generaLog("Errore: " + error)
            erroreAsl5 = { value: error?.response?.data, status: error?.response?.status };
        }
    }
    if (responseAsl5?.status === 200) {
        arr2 = responseAsl5?.data.map(v => ({ ...v, asl: ASL_5.codice }))
    }


    generaLog(arr1)
    generaLog(arr2)
    // --- merge array ---
    const mergedArr = Object.values(arr1.concat(arr2).reduce((r, o) => {
        // Se esiste già un oggetto per questo typeCode, accumula le asl
        if (r[o.typeCode]) {
            r[o.typeCode].asl = Array.isArray(r[o.typeCode].asl)
                ? [...r[o.typeCode].asl, o.asl]
                : [r[o.typeCode].asl, o.asl];
        } else {
            // Se non esiste, crea un nuovo oggetto con asl come array
            r[o.typeCode] = { ...o, asl: [o.asl] };
        }
        return r;
    }, {}));
    generaLog(mergedArr)
    /** per mockare
    [
        {
            id: '0',
            active: true,
            typeCode: 'CL',
            name: 'Screening Colon Retto',
            desc: 'Campagna di Screening per il colon retto',
            asl: [

                '070105'
            ]
        }
    ]
    */

    if (mergedArr.length > 0) {
        // il mergedArr non è vuoto: almeno una delle ASL ha risposto positivamente
        yield put(getCampagneAttiveScreeningActionSuccess({ value: mergedArr, status: 200 }))
        yield put(resetMessaggioStateAction())
    } else {
        // errore in entrambe le ASL: mostro errore all'utente
        const errore =
        {
            ASL_3: erroreAsl3,
            ASL_5: erroreAsl5,
        }
        yield put(getCampagneAttiveScreeningActionSuccess({ value: errore, status: 500 }))
        yield put(setMessaggioAction({ status: ERRORE_GENERICO_API }))
    }



}

function* getCampagneAttiveScreeningWatcher() {
    yield takeEvery(GET_CAMPAGNE_ATTIVE_SCREENING, getCampagneAttiveScreeningWorker);
}


export function* persistentStoreWatchers() {
    yield all([
        getCampagneAttiveScreeningWatcher()
    ]);
}